import React from 'react'

import { Dialog, Flex } from 'components/ds'

import BriefNotes from '../brief-notes'
import styles from './styles.module.css'

interface BriefProjectSettingsDialogProps {
  onOpenChange: (open: boolean) => void
  briefProjectId: string
}

const BriefProjectSettingsDialog: React.FC<BriefProjectSettingsDialogProps> = ({
  onOpenChange,
  briefProjectId,
}) => {
  const handleCancel = () => {
    onOpenChange(false)
  }

  return (
    <Dialog.Root defaultOpen onOpenChange={onOpenChange}>
      <Dialog.Content
        maxWidth="600px"
        aria-describedby={undefined}
        className={styles.dialogContent}
      >
        <Dialog.Title>Project Notes</Dialog.Title>

        <Flex direction="column" flexGrow="1" minHeight="0" height="100%">
          <BriefNotes
            briefProjectId={briefProjectId}
            handleCancel={handleCancel}
          />
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  )
}

export default BriefProjectSettingsDialog
